import Swal from "sweetalert2";
import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card, Empty } from "antd";
import { CopyTextToClipboard } from "../../helpers/copy";
import Apiauth from "../../api/Apiauth";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { Table, Tag } from "antd";
import { t } from "i18next";
import { withTranslation } from "react-i18next";
import { SearchMain } from "../../components/Search";
import AppContext from "antd/es/app/context";
import dayjs from "dayjs";
import "dayjs/locale/th"; // Import Thai locale
import relativeTime from "dayjs/plugin/relativeTime";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
dayjs.extend(relativeTime);
dayjs.locale("th"); // Set Thai as the global locale
class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isData: null,
      isLoad: false,
      formData: {
        username: "",
        password: "",
      },
      dataTable: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {
          // ใช้ dayjs ในการตั้งค่าเริ่มต้น
          startDate: dayjs().startOf("day").format("YYYY-MM-DD"),
          endDate: dayjs().endOf("day").format("YYYY-MM-DD"),
          searchText: undefined,
        },
        sortField: null,
        sortOrder: null,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { tableParams } = this.state;
    const { tableParams: prevTableParams } = prevState;
    const paginationChanged =
      tableParams.pagination?.current !== prevTableParams.pagination?.current ||
      tableParams.pagination?.pageSize !== prevTableParams.pagination?.pageSize;
    const sortChanged =
      tableParams.sortOrder !== prevTableParams.sortOrder ||
      tableParams.sortField !== prevTableParams.sortField;
    const filtersChanged =
      JSON.stringify(tableParams.filters) !==
      JSON.stringify(prevTableParams.filters);
    if (paginationChanged || sortChanged || filtersChanged) {
      this.fetchData();
    }
  }

  showToast = (icon, title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: icon,
      title: title,
    });
  };

  setLoading = (_loading) => this.setState({ isLoad: _loading });

  fetchData = () => {
    this.setLoading(true);
    const { tableParams } = this.state;
    const { startDate, endDate, searchText } = tableParams.filters;

    Apiauth.getActivity_system()
      .then((res) => {
        if (res.data.success) {
          const fetchedData = Array.isArray(res.data.data.rows)
            ? res.data.data.rows
            : [];
          let filteredData = [...fetchedData]; // ใช้ Spread Operator เพื่อสร้าง Array ใหม่

          // Step 1: กรองข้อมูลตามวันที่ก่อน
          if (startDate && endDate) {
            const startOfDay = dayjs(startDate).startOf("day").valueOf();
            const endOfDay = dayjs(endDate).endOf("day").valueOf();

            filteredData = filteredData.filter((item) => {
              const createdAt = dayjs(item.created_at).valueOf();
              return createdAt >= startOfDay && createdAt <= endOfDay;
            });
          }

          // Step 2: ใช้ filteredData จากการกรองวันที่ มากรองด้วย searchText ต่อ
          if (searchText) {
            const lowerSearchText = searchText.toLowerCase();
            filteredData = filteredData.filter((item) =>
              Object.values(item).some((value) =>
                String(value).toLowerCase().includes(lowerSearchText),
              ),
            );
          }

          this.setState((prevState) => ({
            dataTable: filteredData,
            tableParams: {
              ...prevState.tableParams,
              pagination: {
                ...prevState.tableParams.pagination,
                total: filteredData.length,
                current: tableParams.pagination.current,
              },
            },
          }));
        } else {
          this.setState({ dataTable: [] });
          this.showToast(
            "warning",
            res.data.message || "Failed to fetch data.",
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.showToast("error", "Error fetching data.");
      })
      .finally(() => {
        this.setLoading(false);
      });
  };

  handleSearchForm = (value) => {
    this.setState(
      (prevState) => ({
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
          filters: {
            ...prevState.tableParams.filters,
            // ปรับปรุงการจัดการ startDate และ endDate ให้ถูกต้อง
            startDate: value.startDate
              ? dayjs(value.startDate).format("YYYY-MM-DD")
              : undefined,
            endDate: value.endDate
              ? dayjs(value.endDate).format("YYYY-MM-DD")
              : undefined,
            searchText: value.searchText,
            status: value.status,
          },
        },
      }),
      () => this.fetchData(),
    );
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      (prevState) => ({
        tableParams: {
          ...prevState.tableParams,
          pagination,
          filters: {
            ...prevState.tableParams.filters,
            ...filters,
            status: filters.status ? filters.status[0] : undefined,
          },
          sortField: sorter.field,
          sortOrder: sorter.order,
        },
      }),
      () => this.fetchData(),
    );
  };

  render() {
    const { isInbox } = this.props;
    const { activeTabKey1, isLoad, tableParams, dataTable } = this.state;
    const setActiveTabKey1 = (key) => {
      this.setState({ activeTabKey1: key });
    };

    const onTab1Change = (key) => {
      setActiveTabKey1(key);
    };

    const tabList = [
      {
        key: "tab1",
        tab: "รายการกิจกรรม",
      },
    ];
    const columns = [
      {
        title: t("#"),
        key: "computed-id",
        render: (text, record, index) => <>{index + 1}</>,
        width: 70,
      },
      {
        title: t("Username"),
        filterSearch: true,
        dataIndex: "username",
        key: "username",
        render: (text) => (
          <>
            {!text ? (
              <em style={{ color: "#888" }}>
                <small>{t("No data")}</small>
              </em>
            ) : (
              text
            )}
          </>
        ),
      },
      {
        title: t("Activity"),
        filterSearch: true,
        dataIndex: "description",
        key: "description",
        render: (uuid) => (
          <span
            onClick={() => CopyTextToClipboard(uuid)}
            className="text-truncate"
            style={{ cursor: "copy", maxWidth: "60px" }}
          >
            {uuid}
          </span>
        ),
      },
      {
        title: t("Type"),
        filterSearch: true,
        dataIndex: "types",
        key: "types",
        render: (types) => (
          <span style={{ maxWidth: "60px" }} className="text-truncate">
            {types ? (
              types
            ) : (
              <em style={{ color: "#888" }}>
                <small>{t("No data")}</small>
              </em>
            )}
          </span>
        ),
      },

      {
        title: t("Status"),
        dataIndex: "status",
        key: "status",
        render: (status) => {
          let color = status === 1 ? "green" : status === 0 ? "red" : "warning";
          return (
            <Tag
              style={{ textTransform: "uppercase", fontWeight: "700" }}
              color={color}
              key={status}
            >
              {status === 1 ? "Success" : "Failed"}
            </Tag>
          );
        },
        filters: [
          {
            text: "Success",
            value: 1,
          },
          {
            text: "Failed",
            value: 0,
          },
        ],
        onFilter: (value, record) => record.status === value,
        filterSearch: false,
      },
      {
        title: t("note"),
        filterSearch: true,
        dataIndex: "note",
        key: "note",
        render: (note) => (
          <span style={{ textTransform: "uppercase" }}>
            {note ? (
              note
            ) : (
              <em style={{ color: "#888" }}>
                <small>{t("No data")}</small>
              </em>
            )}
          </span>
        ),
      },
      {
        title: t("IP"),
        dataIndex: "IP",
        filterSearch: true,
        key: "IP",
        render: (IP) => (
          <span
            onClick={() => CopyTextToClipboard(IP)}
            style={{ cursor: "copy" }}
          >
            {IP ? (
              <span style={{ color: "#3eacff" }}>{IP}</span>
            ) : (
              <em style={{ color: "#888" }}>
                <small>{t("No data")}</small>
              </em>
            )}
          </span>
        ),
      },
      {
        title: t("ceatedAt"),
        dataIndex: "created_at",
        filterSearch: true,
        key: "created_at",
        render: (date) => (
          <span>
            {date ? (
              FormatTimeAgo(date)
            ) : (
              <em style={{ color: "#888" }}>
                <small>No data</small>
              </em>
            )}
          </span>
        ),
      },
    ];

    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.id}
              onChange={this.handleTableChange}
              dataSource={dataTable}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("No data")}
                  />
                ),
              }}
              loading={isLoad}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`,
                },
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = tableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
    };

    const type = `${t("Type : Activity")}`;

    return (
      <>
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("Activity")}
                Breadcrumb={
                  isInbox
                    ? [
                      {
                        name: removeSlashesFromPath(window.location.pathname),
                        navigate: window.location.pathname,
                      },
                    ]
                    : null
                }
              />
              {isInbox ? (
                <>
                  <SearchMain
                    t={t}
                    onSearch={this.handleSearchForm}
                    activeKey1={window.location.pathname}
                    type={type}
                  />
                  <Card
                    title={<></>}
                    extra={<></>}
                    tabList={tabList}
                    activeTabKey={activeTabKey1}
                    onTabChange={onTab1Change}
                  >

                    {contentList[activeTabKey1]}
                  </Card>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});
export default connect(mapStateToProps, {})(withTranslation()(Index));
